import * as React from 'react';
// @ts-ignore
import { animated, Transition } from 'react-spring';
import styled from 'styled-components';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import { theme } from '../../theme';

type ModalProps = StyledSystemProps & {
  onClose: () => null;
  children: React.ReactNode;
  open: boolean;
};

export const ModalWrap = styled(animated.div)`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${theme.zIndex[12]};
  height: calc(100vh / var(--ib-ui-scale, 1));
  display: flex;
  padding: 150px;
  position: fixed;
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.3);
`;

const CustomModalInner = styled(animated.div)<any>`
  width: 100%;
  display: inline-block;
  max-width: 100%;
  border-radius: 5px;
  background-color: white;
  box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.17);
`;

const CustomText = styled.h2<any>``;

const SessionExpireModal: React.FC<ModalProps> = ({ children, open }) => (
  <Transition
    items={open}
    native={true}
    from={{
      opacity: 0,
      transform: 'translateY(40px)',
    }}
    enter={{
      opacity: 1,
      transform: 'translateY(0)',
    }}
    leave={{
      opacity: 0,
      transform: 'translateY(40px)',
      pointerEvents: 'none',
    }}
  >
    {(modalOpen: any) =>
      modalOpen &&
      ((props: any) => (
        <ModalWrap style={{ opacity: props.opacity }}>
          <CustomModalInner>
            <CustomText>Your session is about to expire in {children}</CustomText>
            <CustomText>Please double click or scroll anywhere to keep your session active</CustomText>
          </CustomModalInner>
        </ModalWrap>
      ))
    }
  </Transition>
);

export default SessionExpireModal;
